// extracted by mini-css-extract-plugin
export default {"container":"Cmyc3","searchForm":"c6lLg","input":"_7l2r8","labelText":"ev9Fk"};